import React from "react";
import Subscriber from "../../subscriber.class";
// import Spinner from "../../components/Spinners/Spinner";
import Storage from "../../services/storage.service";
// import Globals from "./../../services/globals";
// import User from "../../services/user";
// import Settings from "../../services/settings";
import Chats from "../../services/chat.service";

export default class NewMessage extends Subscriber {
  state = {
    message: "",
    ticket: false
  };

  keyUp = e => {
    var code = e.keyCode || e.which;
    if (code === 13) {
      this.trySendMessage();
    }
  };

  sendMessage = (retry = true) => {
    if (this.state.message) {
      if (this.state.ticket) {
        Chats.sendMessage(Storage.get("ticket"), this.state.message);
        this.setState({
          message: ""
        });
      } else {
        if (retry) {
          Chats.addTicket()
            .then(res => {
              setTimeout(()=>{
                this.sendMessage(false);
              }, 500);
              
            })
            .catch(err => {
              // @Todo handle error
            });
        }
      }
    }
  };

  trySendMessage = (retry = true) => {
    if (Storage.get("ticket_is_closed")) {
      Chats.clearTicketAndOpenNew()
        .then(r => {
          this.sendMessage(retry);
        })
        .catch(errr => {
          // @Todo handle error
        });
    } else {
      this.sendMessage(retry);
    }
  };

  changeHandler = e => {
    let message = e.target.value;
    message = message.replace(/\n/g, "");
    let new_state = {
      message: message
    };
    this.setState(new_state);
  };

  componentDidMount() {
    this.subscriptions.push(
      Storage.get_obsrv("ticket").subscribe(ticket => {
        this.setState({
          ticket: ticket ? true : false
        });
      })
    );
  }

  render() {
    let content = "";
    // if () {
    content = (
      <div className="new_message">
        <div className="new_message_input">
          <textarea
            onChange={this.changeHandler}
            onKeyUp={this.keyUp}
            placeholder="Write a message .."
            value={this.state.message}
          />
        </div>
        <div className="new_message_action">
          <div className="send_button" onClick={this.trySendMessage}>
            Send
          </div>
        </div>
      </div>
    );
    // }
    return content;
  }
}